import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';
import { CustomHttp } from '../shared/custom.http';
import { Eventlog } from './model/eventlog';


@Injectable()
export class EventlogService {
    private eventLogUrl = '/tms/note';

    constructor(private router: Router, private http: CustomHttp) { }

    getAllNotes() {
        return this.http.get(this.eventLogUrl);
    }

    postNote(eventlog: Eventlog) {
        const url = `${this.eventLogUrl}?content_id=${eventlog.content_id}`;
        return this.http.post(url, eventlog);
    }
}



// WEBPACK FOOTER //
// ./src/app/tms/eventlog.service.ts